import { useEffect, useState } from "react";

const DURATION_SECONDS = 17 * 60 + 34;
const START = Date.now();

function remaining(): number {
  const elapsed = Math.floor((Date.now() - START) / 1000);
  return DURATION_SECONDS - (elapsed % DURATION_SECONDS);
}

/** Shared countdown that starts at 00:17:34 and restarts automatically when it reaches zero. */
export function useCountdown() {
  const [seconds, setSeconds] = useState(remaining);

  useEffect(() => {
    const id = window.setInterval(() => setSeconds(remaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  return {
    hours: Math.floor(seconds / 3600),
    minutes: Math.floor((seconds % 3600) / 60),
    seconds: seconds % 60,
  };
}
